//
//
//
//

export default {
  data: function data() {
    return {
      id: '',
      route: '',
      token: '',
      userId: ''
    };
  },
  created: function created() {
    this.$route.query.id;
    if (this.$route.query.userId) {
      this.postUserId();
    } else if (this.$route.query.token) {
      this.postToken();
    } else if (this.$route.query.employeeNum) {
      this.postEmployeeNum();
    }
  },
  methods: {
    postUserId: function postUserId() {
      var self = this;
      Lib.M.ajax({
        'method': "POST",
        'url': 'open/pm-login/userId?userId=' + this.$route.query.userId,
        'params': {},
        'headers': {
          appId: 'KS4PEszy',
          appSecret: '9684e632912b54c40c8ba84efbae97112a5dc4f3'
        },
        'success': function success(data) {
          sessionStorage.setItem("data", JSON.stringify(data.obj.user));
          sessionStorage.setItem("token", JSON.stringify(data.obj.token));
          self.$upload.defaults.headers.common["token"] = data.obj.token.tokenId;
          localStorage.setItem("token", JSON.stringify(data.obj.token));
          sessionStorage.setItem("permission", JSON.stringify(data.obj.permission));
          sessionStorage.setItem("menu", JSON.stringify(data.obj.menu));
          sessionStorage.setItem("menuEng", JSON.stringify(data.obj.menuEng));
          sessionStorage.setItem("permissionEng", JSON.stringify(data.obj.permissionEng));
          self.$store.dispatch("dispatchIsLogin", 1);
          console.log('self.$route.query', self.$route.query);
          if (self.$route.query.route) {
            console.log('self.$route.query.route', self.$route.query.route);
            window.location.href = "#/main/" + decodeURI(self.$route.query.route);
          } else {
            window.location.href = "#/main/portal";
          }
        }
      });
    },
    postToken: function postToken() {
      var self = this;
      Lib.M.ajax({
        'method': "POST",
        'url': 'open/pm-login?token=' + this.$route.query.token,
        'params': {},
        'headers': {
          appId: 'KS4PEszy',
          appSecret: '9684e632912b54c40c8ba84efbae97112a5dc4f3'
        },
        'success': function success(data) {
          sessionStorage.setItem("data", JSON.stringify(data.obj.user));
          sessionStorage.setItem("token", JSON.stringify(data.obj.token));
          self.$upload.defaults.headers.common["token"] = data.obj.token.tokenId;
          localStorage.setItem("token", JSON.stringify(data.obj.token));
          sessionStorage.setItem("permission", JSON.stringify(data.obj.permission));
          sessionStorage.setItem("menu", JSON.stringify(data.obj.menu));
          sessionStorage.setItem("menuEng", JSON.stringify(data.obj.menuEng));
          sessionStorage.setItem("permissionEng", JSON.stringify(data.obj.permissionEng));
          self.$store.dispatch("dispatchIsLogin", 1);
          if (self.$route.query.route) {
            if (self.$route.query.id) {
              window.location.href = "#/main/" + self.$route.query.route + '?id=' + self.$route.query.id;
            } else {
              window.location.href = "#/main/" + self.$route.query.route;
            }
          } else {
            window.location.href = "#/main/portal";
          }
        }
      });
    },
    postEmployeeNum: function postEmployeeNum() {
      var self = this;
      Lib.M.ajax({
        'method': "POST",
        'url': 'open/login/employeeNum?employeeNum=' + this.$route.query.employeeNum,
        'params': {},
        'headers': {
          appId: 'KS4PEszy',
          appSecret: '9684e632912b54c40c8ba84efbae97112a5dc4f3'
        },
        'success': function success(data) {
          sessionStorage.setItem("data", JSON.stringify(data.obj.user));
          sessionStorage.setItem("token", JSON.stringify(data.obj.token));
          self.$upload.defaults.headers.common["token"] = data.obj.token.tokenId;
          localStorage.setItem("token", JSON.stringify(data.obj.token));
          sessionStorage.setItem("permission", JSON.stringify(data.obj.permission));
          sessionStorage.setItem("menu", JSON.stringify(data.obj.menu));
          sessionStorage.setItem("menuEng", JSON.stringify(data.obj.menuEng));
          sessionStorage.setItem("permissionEng", JSON.stringify(data.obj.permissionEng));
          self.$store.dispatch("dispatchIsLogin", 1);
          console.log('self.$route.query', self.$route.query);
          if (self.$route.query.route) {
            console.log('self.$route.query.route', self.$route.query.route);
            window.location.href = "#/main/" + decodeURI(self.$route.query.route);
          } else {
            window.location.href = "#/main/portal";
          }
        }
      });
    }
  }
};